import { defineMessages } from 'react-intl';

const translations = {
  edit: {
    title: {
      id: 'pages.users.edit.title',
      defaultMessage: 'Edit user',
      description: 'Title of the edit user drawer',
    },
  },
  confirmDeleteUser: {
    title: {
      id: 'pages.users.confirmDeleteUser.title',
      defaultMessage: 'Delete user',
      description: 'title of the delete user confirm',
    },
    description: {
      id: 'pages.users.confirmDeleteUser.description',
      defaultMessage: 'Are you sure you want to delete this user?',
      description: 'description of the delete user confirm',
    },
    actions: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'label of the cancel button of the confirm delete user dialog',
      },
      delete: {
        id: 'actions.delete',
        defaultMessage: 'Delete',
        description: 'label of the delete button of the confirm delete user dialog',
      },
    },
  },
  feedback: {
    userUpdated: {
      id: 'pages.users.feedback.userUpdated',
      defaultMessage: 'User updated',
      description: 'success feedback message of the user update action',
    },
    userNotUpdated: {
      id: 'pages.users.feedback.userNotUpdated',
      defaultMessage: 'User could not be updated',
      description: 'error feedback message of the user update action',
    },
    userDeleted: {
      id: 'pages.users.feedback.userDeleted',
      defaultMessage: 'User deleted',
      description: 'success feedback message of the user delete action',
    },
    userNotDeleted: {
      id: 'pages.users.feedback.userNotDeleted',
      defaultMessage: 'User could not be deleted',
      description: 'error feedback message of the user delete action',
    },
  },
};

export default defineMessages(translations);
